import loadSvgWithCached from './loadSvgWithCached';
import filterUnavailableSvgContent from './filterUnavailableSvgContent';
import { setSvgAttr } from './utils';
var injectedElements = [];
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
export default function injectElement(wrapperElement, url, svgConfig) {
  if (svgConfig === void 0) {
    svgConfig = {};
  }
  var findIndex = injectedElements.indexOf(wrapperElement);
  if (findIndex !== -1) {
    injectedElements.splice(findIndex, 1);
    return;
  }
  injectedElements.push(wrapperElement);
  loadSvgWithCached(url, function (error, svg) {
    if (error || !(svg instanceof SVGSVGElement)) {
      // eslint-disable-next-line no-console
      console.error(error || svg);
      injectedElements.splice(injectedElements.indexOf(wrapperElement), 1);
      return;
    }
    var cloneSvg = svg.cloneNode(true);
    filterUnavailableSvgContent(cloneSvg, url);
    // 添加svg默认值
    cloneSvg.setAttribute('xmlns', svgNamespace);
    cloneSvg.setAttribute('xmlns:xlink', xlinkNamespace);
    setSvgAttr(cloneSvg, svgConfig);
    wrapperElement.appendChild(cloneSvg);
    injectedElements.splice(injectedElements.indexOf(wrapperElement), 1);
  });
}